import React from 'react';
import PropTypes from 'prop-types';
import Button from 'tailwind-components/Button/Button';
import { cn } from 'lib/utils';

function TabButton({ tab, isActive, onClick, className }) {
  const activeClass = tab.activeClassName ?? '';
  const inactiveClass = 'hover:bg-grey-lighter bg-grey-lightest';

  return (
    <Button
      type='button'
      size='small'
      rounded='medium'
      variant={isActive ? 'secondary' : ''}
      noHoverEffects={isActive}
      onClick={onClick}
      icon={tab.icon}
      text={tab.label}
      data-tour={tab.dataTour}
      className={cn(
        isActive ? activeClass : inactiveClass,
        tab.className,
        className
      )}
    />
  );
}

TabButton.propTypes = {
  tab: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.node,
    className: PropTypes.string,
    activeClassName: PropTypes.string,
    dataTour: PropTypes.string
  }).isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default TabButton;
